import { render, staticRenderFns } from "./PermanentLinkDialog.vue?vue&type=template&id=f67abe46&scoped=true&"
import script from "./PermanentLinkDialog.vue?vue&type=script&lang=js&"
export * from "./PermanentLinkDialog.vue?vue&type=script&lang=js&"
import style0 from "./PermanentLinkDialog.vue?vue&type=style&index=0&id=f67abe46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67abe46",
  null
  
)

export default component.exports